module.exports = __webpack_public_path__ + "img/collection-engagementRingsRosegold.30e5c47.webp";